import {createSlice} from '@reduxjs/toolkit'
import {RootState} from '../../store'
import {IFetchInvoiceParams} from '../../api/modules/master-data/types'

export interface IInvoiceState {
  filter?: IFetchInvoiceParams
}

const initialState: IInvoiceState = {
  filter: {
    invoice_number: '',
    so_number: '',
    so_number_sap: '',
    customer_code: '',
    customer_name: '',
    sales_org_code: '',
    invoice_date: '',
    due_date: '',
    incoterm: '',
    currency: '',
    top: '',
    total_quantum: '',
    total_price: '',
    invoice_number_sap: '',
    status: '',
    per_page: 25,
  },
}

/**
 * Slice
 */
const invoiceSlice = createSlice({
  name: 'invoice',
  initialState,
  reducers: {
    setFilter: (state, action) => ({...state, filter: action.payload}),
    resetFilter: (state) => ({...state, filter: initialState.filter}),
  },
})

/**
 * Action
 */
export const {setFilter, resetFilter} = invoiceSlice.actions

/**
 * Selector
 */
export const invoiceSelector = (state: RootState) => state.invoiceReducer

/**
 * Reducer
 */
export default invoiceSlice.reducer
